import WCardFormDataMixin from './w-card-form-data-mixin'
import WPasswordField from '../../components/WPasswordField'
import Logo from '../../assets/img/logo.png'

/**
 * @mixin
 */
export default {
    mixins: [WCardFormDataMixin],
    components: {
        WPasswordField
    },
    data: () => ({
       passwordConfirmErrorMessage: []
    }),
    props: {
        /**
         * Text to show to prompt user to take the alternative route (e.g. 'Having trouble?').
         */
        alternativeRouteText: {
            type: String,
            default: 'Do you want to login?'
        },
        /**
         * Hide the close icon.
         */
        hideCloseButton: {
            type: Boolean,
            default: true
        },
        /**
         * Hide the close icon.
         */
        hideSecondaryButton: {
            type: Boolean,
            default: true
        },
        /**
         * Path to logo.
         */
        logoSrc: {
            type: String,
            default: Logo
        },
        /**
         * URL parameters to be sent back upon successful form submission.
         */
        urlParams: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        handleSubmit () {
            /**
             * Submit event.
             * @type {object}
             */
            if (this.canSubmit) {
                this.$emit('submit', {...this.urlParams, ...this.formData})
            }
        },
        checkPasswordsMatch () {
            const vm = this
            const fd = vm.formData
            if (fd.password_confirm) {
                // sets an error message in the password confirm input field if pwds don't match
                vm.passwordConfirmErrorMessage = fd.password !== fd.password_confirm ? 'Passwords do not match' : []
            }
        },
        updatePassword (val) {
            const vm = this
            vm.setFieldData('password', val)
            vm.checkPasswordsMatch()
        },
        updatePasswordConfirm (val) {
            const vm = this
            vm.setFieldData('password_confirm', val)
            vm.checkPasswordsMatch()
        }
    }

}
